import { memo, useEffect, useState } from 'react';

import {
  isSameDayInTimeZone,
  minutesFromDayStart,
  startOfDayInTimeZone
} from '../../utils/dateGrid';

import type { CurrentTimeIndicatorProps } from './types';

const UPDATE_INTERVAL_MS = 60_000;

function CurrentTimeIndicator({
  day,
  minMinutes,
  maxMinutes,
  pxPerMinute,
  timeZone
}: CurrentTimeIndicatorProps) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), UPDATE_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  if (!isSameDayInTimeZone(now, day, timeZone)) return null;

  const nowMinutes = minutesFromDayStart(now, startOfDayInTimeZone(day, timeZone), timeZone);
  if (nowMinutes < minMinutes || nowMinutes > maxMinutes) return null;

  return (
    <div
      className="pointer-events-none absolute inset-x-0 z-10 flex items-center"
      style={{ top: (nowMinutes - minMinutes) * pxPerMinute }}>
      <div className="-ml-1 h-2 w-2 shrink-0 rounded-full bg-uniform-red-500" />
      <div className="h-px w-full bg-uniform-red-500" />
    </div>
  );
}

export default memo(CurrentTimeIndicator);
